import { render, staticRenderFns } from "./AttachmentStep.vue?vue&type=template&id=5fc5568d"
import script from "./AttachmentStep.vue?vue&type=script&lang=ts"
export * from "./AttachmentStep.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports